export const IconPlus: {
  name: 'icon_plus-c911fada9dbb'
} = {
  name: 'icon_plus-c911fada9dbb'
}
